import React from 'react';
import LogoWom from '../../../images/logowom.svg';
import { MainNavStyled, LogoContainerStyled } from './styles/NavStyled';

const Nav = () => {
  return (
    <MainNavStyled className="nav_row">
      <LogoContainerStyled>
        <img className="logo-nav" src={LogoWom} alt="logo WOM" />
      </LogoContainerStyled>
    </MainNavStyled>
  );
};

export default Nav;
